module.exports = __webpack_public_path__ + "static/media/delete-24px.16793e81.svg";